/**
 * Enlace de WhatsApp a la propiedad (inventario D51): siempre con la referencia de la reserva al principio del
 * mensaje, para que la propiedad sepa de qué reserva se trata. Es la única forma de construir un enlace wa.me en v2.
 */
export function whatsappHref(number: string, reference: string, message?: string): string {
  const text = message ? `${reference} · ${message}` : reference
  return `https://wa.me/${number.replace(/\D/g, '')}?text=${encodeURIComponent(text)}`
}
